(() => {
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  const SEC = 'zi-cart-drawer';
  const lock = (on) => { document.body.style.overflow = on ? 'hidden' : ''; };
  const drawer = () => document.getElementById('zi-cd');
  const open = () => { const d = drawer(); if (!d) return; d.hidden = false; lock(true); d.querySelector('.zi-cd__close')?.focus(); };
  const close = () => { const d = drawer(); if (!d) return; d.hidden = true; lock(false); };
  const paint = (sections, count) => {
    const wrap = document.getElementById('shopify-section-' + SEC);
    if (wrap && sections && sections[SEC]) {
      const html = new DOMParser().parseFromString(sections[SEC], 'text/html').getElementById('shopify-section-' + SEC);
      if (html) wrap.innerHTML = html.innerHTML;
    }
    if (count !== undefined) document.querySelectorAll('[data-zi-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
  };
  const post = async (url, body) => {
    const res = await fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: SEC }) });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Er ging iets mis');
    return data;
  };
  window.ziCart = {
    open, close,
    async add(id, quantity = 1) {
      const data = await post('cart/add.js', { items: [{ id: Number(id), quantity }] });
      const cart = await (await fetch(root + 'cart.js')).json();
      paint(data.sections, cart.item_count);
      open();
    },
    async change(line, quantity) {
      const data = await post('cart/change.js', { line, quantity });
      paint(data.sections, data.item_count);
      drawer().hidden = false;
    }
  };

  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-zi-tab]');
    if (tab) {
      const r = tab.closest('[data-zi-tabs]');
      r.querySelectorAll('[data-zi-tab]').forEach((t) => t.setAttribute('aria-selected', t === tab));
      r.querySelectorAll('[data-zi-panel]').forEach((p) => { p.hidden = p.dataset.ziPanel !== tab.dataset.ziTab; });
      return;
    }
    if (e.target.closest('[data-zi-drawer]')) {
      const d = document.getElementById('zi-drawer'); d.hidden = !d.hidden; lock(!d.hidden); return;
    }
    if (e.target.closest('[data-zi-cart-open]') && drawer()) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-zi-cd-close]')) { close(); return; }
    const q = e.target.closest('[data-zi-line]');
    if (q) {
      q.disabled = true;
      window.ziCart.change(Number(q.dataset.ziLine), Number(q.dataset.qty)).catch((err) => alert(err.message));
    }
    const ft = e.target.closest('[data-zi-filters-toggle]');
    if (ft) { const f = document.getElementById('zi-filters'); f.classList.toggle('is-open'); lock(f.classList.contains('is-open')); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-zi-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button');
    btn.disabled = true;
    try { await window.ziCart.add(form.elements.id.value, 1); }
    catch (err) { alert(err.message); }
    finally { btn.disabled = false; }
  });

  document.addEventListener('change', (e) => {
    const f = e.target.closest('[data-zi-autosubmit]');
    if (f) f.requestSubmit ? f.requestSubmit() : f.submit();
  });
})();
